import { useTVService } from '@/app/context/DIContext/DIServices'
import Config from '@/shared/config/config'
import Channel from '@/shared/classes/channels/channel'

const useTVRepository = () => {
    const {
        getApiChannelsList,
        checkIfChannelsVersionChanged,
        getGroupedTvRadioChannels,
    } = useTVService()

    const getChannelsList = (token: string | null) => getApiChannelsList(token)
    const shouldUpdateChannelsList = (
        previousLocalConfig: Config | null | undefined
    ) => checkIfChannelsVersionChanged(previousLocalConfig)
    const getTvRadioChannels = (channels: Channel[]) =>
        getGroupedTvRadioChannels(channels)
    return { getChannelsList, shouldUpdateChannelsList, getTvRadioChannels }
}

export { useTVRepository }
